<template>
  <div class="col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
    <bar-chart class="col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4"
               :options="chartOptions"
               :chart-data="ordersHistory"/>
    <data-table :entity="'client'"
                :columns="columns"
                :data="sortedResults.reverse()"
                :is-loading="loading"
                :disablePermissionChecks="true"
                rowNavigationKey="client_uuid"
                operations="refresh,edit"
                class="col-span-2"
                ref="table">
      <template v-slot:month="{row}">
        {{$formatDate(new Date(year, row.date_month - 1, 1), 'MMM')}}
      </template>
      <template v-slot:orders_sales="{ row }">
        <strong>{{ parseFloat(row.orders_sales) | toCurrency }}</strong>
      </template>
    </data-table>
  </div>
</template>
<script>
import format from 'date-fns/format'
import BarChart from 'src/components/Charts/BarChart'
import ReportService from 'src/services/ReportService'
import orderBy from 'lodash/orderBy'

export default {
  components: {
    BarChart
  },
  props: {
    dateFrom: {
      type: String,
      default: `${new Date().getFullYear()}-01-01`
    },
    dateTill: {
      type: String,
      default: format(new Date(), 'yyyy-MM-dd'),
    },
  },
  data () {
    return {
      year: new Date().getFullYear(),
      ordersHistoryTotals: {
        results: []
      },
      chartColors: ['#5145cd', '#31c48d', '#0694a2', '#F9703E', '#e02424'],
      loading: false,
    }
  },
  computed: {
    ordersHistoryReport () {
      return {
        model: 'orders',
        group: 'month',
        select: 'id,total,client,orders_sales',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month,year',
        'where[client_uuid]': this.$route.params.id,
      }
    },
    columns () {
      return [
        {
          label: this.$t('generic.month'),
          prop: 'month'
        },
        {
          label: this.$t('reports.sales'),
          prop: 'orders_sales'
        }
      ]
    },
    sortedResults () {
      return orderBy(this.ordersHistoryTotals.results, 'date_format', 'asc')
    },
    chartOptions () {
      if (!this.allJobBoards) {
        return {}
      }
      return {
        scales: {
          yAxes: [{
            stacked: true
          }],
          xAxes: [{
            stacked: true
          }]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    },
    ordersHistory () {
      return {
        labels: this.sortedResults.map(r => this.$formatDate(new Date(this.year, r.date_month - 1, 1), 'MMM')),
        datasets: [
          {
            label: this.$t('reports.sales'),
            backgroundColor: '#31c48d',
            data: this.sortedResults.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: parseFloat(r.orders_sales),
            }))
          }
        ]
      }
    }
  },
  methods: {
    async getOrderHistoryReport () {
      try {
        this.loading = true
        const {data} = await ReportService.get(this.ordersHistoryReport)
        this.ordersHistoryTotals = data
        this.$emit('data-loaded', this.ordersHistoryTotals)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    dateFrom () {
      this.getOrderHistoryReport()
    },
    dateTill () {
      this.getOrderHistoryReport()
    }
  },
  mounted () {
    this.getOrderHistoryReport()
  }
}
</script>
<style>
</style>
